import { Context } from '@/models/order-history/status/context/context'
import { OrderCancellationState } from '@spa/components/organisms/mypage/order/model/order-cancellation-state'
import { CreateOrderCancellationStateCommand } from '@spa/components/organisms/mypage/order/model/order-cancellation-state/create-command'

interface ApplicableContext extends Context {
  paymentType: 'np-postpay'
}
/**
 * @internal モジュールの外部からはgetOrderCancellationStateを利用すること
 */
export class ForCvsNumber extends CreateOrderCancellationStateCommand<ApplicableContext> {
  shouldApply(context: Context): context is ApplicableContext {
    return context.paymentType === 'cvs-number'
  }
  protected createState(_context: ApplicableContext): OrderCancellationState {
    return {
      /**
       * コンビニ決済では支払い済みでもキャンセル不可
       * @see https://github.com/my-color/front/issues/7093
       */
      isCancellable: false,
    }
  }
}
